import { appContext } from "../../../../AppContext";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { JSX } from "react";
import { SerendieSymbol } from "@serendie/symbols";
import { Switch } from "@serendie/ui";
import { Card, GridContainer, GridItem, Select, TextField } from "@iconics/components";
import { TypeHelper } from "@iconics/core";
import { IdentityProvider } from "./DataModels";

export default class Details extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            identityProviderOptions: [],
        };
    }

    public render(): JSX.Element
    {
        const identityProviderOptions = this.props.identityProviders.map(i => ({ value: i.Id.toString(), label: i.Name }));
        const identityProviderName = identityProviderOptions.find(x => x.value === this.props.identityProviderId?.toString())?.label ?? '';
        return (
            <Card
                title={this.labels.Platform_Role_DetailsTitle}
                subTitle={this.labels.Platform_Role_DetailsSubTitle}
                icon={<SerendieSymbol name='apps-circle' />}
            >
                <GridContainer>
                    <GridItem>
                        <TextField
                            label={this.labels.Role_Name}
                            value={this.props.name ?? ""}
                            required
                            onChange={e => this.props.onNameChange(e.target.value)}
                            invalid={!!this.props.nameError}
                            invalidMessage={this.props.nameError}
                            disabled={this.props.nameDisabled}
                        />
                    </GridItem>
                    <GridItem>
                        <Switch
                            label={this.labels.Role_IsOwner}
                            checked={this.props.isOwner}
                            onCheckedChange={e => this.props.onIsOwnerChange(e.checked)}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.Role_DisplayName}
                            placeholder={this.labels.Role_DisplayName}
                            value={this.props.displayName}
                            onChange={e => this.props.onDisplayNameChange(e.target.value)}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <Select
                            label={this.labels.Role_IdentityProviderId}
                            placeholder={identityProviderName}
                            required
                            disabled={this.props.roleId !== "0"}
                            onSelect={e => this.props.onIdentityProviderChange(TypeHelper.toNumber(e.value) ?? 0)}
                            items={identityProviderOptions}
                            invalid={!!this.props.identityProviderError}
                            invalidMessage={this.props.identityProviderError}
                        />
                    </GridItem>
                    {
                        this.props.identityProviderId !== 1 &&
                        <GridItem expanded={6}>
                            <TextField
                                label={this.labels.Role_GroupId}
                                value={this.props.groupId ?? ""}
                                placeholder={"00000000-0000-0000-0000-00000000000"}
                                onChange={e => this.props.onGroupChange(e.target.value)}
                                disabled={this.props.groupDisabled}
                            />
                        </GridItem>
                    }
                </GridContainer>
            </Card>
        );
    }
}

export interface IProps
{
    roleId: string;
    name?: string;
    nameError: string;
    nameDisabled: boolean;
    displayName: string;
    identityProviderId?: number;
    identityProviderError: string;
    identityProviders: IdentityProvider[];
    groupId?: string;
    groupDisabled: boolean;
    isOwner: boolean;
    onNameChange: (value: string) => void;
    onIsOwnerChange: (value: boolean) => void;
    onDisplayNameChange: (value: string) => void;
    onIdentityProviderChange: (value: number) => void;
    onGroupChange: (value: string) => void;
}

export interface IState
{
    identityProviderOptions: { label: string, value: number }[];
}
